import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Button } from '@mui/material';
import { memo } from 'react';
import type { ViewRecordButtonProps as Props } from './types';

export const ViewRecordButton = memo(
  ({ className, onOpen, isOpen, compact }: Props) => {
    return (
      <Button
        onClick={onOpen}
        className={classnames(
          'ViewRecordButton',
          { viewRecordState: isOpen },
          className
        )}
        startIcon={<Icon name="mosaic" />}
        size="small"
        variant="text"
        color="default"
        children={compact ? null : 'View Records'}
      />
    );
  }
);

ViewRecordButton.displayName = 'ViewRecordButton';
